import { inject, Injectable } from '@angular/core';
import { ApiHttpService } from '../../api-http.service';
import { DocumentSections, SupplierCreditNoteItem } from '../../../models';
import { map, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SupplierCreditNoteItemService {
  apiService: ApiHttpService<SupplierCreditNoteItem> = inject(ApiHttpService<SupplierCreditNoteItem>);

  getForSupplierCreditNote(iri: string): Observable<DocumentSections<SupplierCreditNoteItem>> {
    return this.apiService
      .getMany(`${iri}/supplier_credit_note_items`)
      .pipe(map((result) =>
        ({ [iri]: result.body['hydra:member'] as SupplierCreditNoteItem[] })
      ));
  }

  patch(
    iri: string,
    updatedRecord: Record<string, string | number | null | boolean | undefined> | SupplierCreditNoteItem
  ): Observable<SupplierCreditNoteItem> {
    return this.apiService.patch(iri, updatedRecord as unknown as SupplierCreditNoteItem)
      .pipe(take(1),map((result) => result.body));
  }
}
